import Header from 'components/Header/Header'
import './style.css'
import First from 'components/Contact/Fisrt'

const Contact = () => {

  return (
    <>
      <Header isOverLay={false} />
      <First />
    </>
  )
}

export default Contact
